// extracted by mini-css-extract-plugin
module.exports = {"search-results-wrapper":"load-more-search-results-m__search-results-wrapper__28JPE","stories-wrapper":"load-more-search-results-m__stories-wrapper__2W3wa"};